'use client';
import React from 'react';
import styles from './style.module.scss';
import Typography from '@/components/shared/typography/typography.component';
import colors from '@/theme/colors.module.scss';

const TabButton = ({
  active,
  label,
  onClick,
}: {
  active: boolean;
  label: string;
  onClick: () => void;
}) => {
  return (
    <div className={`${styles.button} ${active && styles.buttonActive}`} onClick={onClick}>
      <Typography variant={'body2Medium'} color={active ? colors.primary700 : colors.gray}>
        {label}
      </Typography>
    </div>
  );
};

export default TabButton;
